import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {httpInterceptorProviders} from './interceptors/interceptor.index';
import {AppRoutingModule} from './app-routing.module';
import {SharedModule} from './shared/shared.module';
import {UserModule} from './components/users/user.module';
import {HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LoginModule} from './components/authentication/login/login.module';
import {RegistrationModule} from './components/authentication/registration/registration.module';
import {CoreModule} from './components/core/core.module';
import {PermissionModule} from './components/permissions/permission.module';
import {GroupModule} from './components/groups/group.module';
import {DashboardModule} from './components/dashboard/dashboard.module';
import {FileModule} from "./components/file/file.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FirmwareModule} from './components/firmware/firmware.module';
import {ModuleTypeModule} from './components/module-type/module-type.module';
import {DisplayTypeModule} from './components/display-type/display-type.module';
import {ChipTypeModule} from './components/chip-type/chip-type.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    FontAwesomeModule,
    CoreModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,
    AppRoutingModule,
    UserModule,
    PermissionModule,
    GroupModule,
    FileModule,
    LoginModule,
    RegistrationModule,
    DashboardModule,
    FirmwareModule,
    ModuleTypeModule,
    DisplayTypeModule,
    ChipTypeModule
  ],
  exports: [],
  providers: [
    httpInterceptorProviders
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
}
